import React, { useEffect } from "react";
import { loadingsShow } from "../../Services/PostAPI";
import { APP_URLS } from "../../constants/urlConstants";
import { generatePath } from "react-router-dom";
import CustomerComponent from "../../components/Customer";
import { connect } from "react-redux";
import customerData from "./tableData.json";

import {
  fetchCustomer,
  initializeCustomerScreen,
} from "../../Redux/Actions/customer";

const CustomerScreen = (props) => {
  const {
    fetchCustomers,
    history,
    initCustomerScreen,
    showPageLevelLoader,
    customerList,
    paginationInfo,
    screenPermissions,
    isLoading,
    isPageLevelError,
  } = props;

  useEffect(() => {
    initCustomerScreen();
    fetchCustomers();
  }, []);

  const updateCustomer = ({ id }) => {
    const path = generatePath(APP_URLS.CUSTOMER.EDIT_CUSTOMER, {
      id: id,
    });
    history.push(path);
  };

  const loadLazyData = (props) => {
    fetchCustomers(props);
  };

  const createCustomerCompany = () => {
    history.push(APP_URLS.CUSTOMER.ADD_CUSTOMER);
  };

  const customerProps = {
    // readCustomer,
    ...customerData,
    fetchCustomers: loadLazyData,
    tableData: {
      ...customerData.tableData,
      rows: customerList.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    createCustomerCompany,
    updateCustomer,
    isPageLevelError,
    screenPermissions
  };

  if (showPageLevelLoader) {
    loadingsShow("block");
    return null;
  }

  loadingsShow("none");
  return <CustomerComponent {...customerProps} />;
};

const mapStateToProps = (state) => ({
  customerList: state.customerReducer.customerList,
  paginationInfo: state.customerReducer.paginationInfo,
  isLoading: state.customerReducer.isLoading,
  showPageLevelLoader: state.customerReducer.isLoadingPage,
  isPageLevelError: state.customerReducer.isPageLevelError,
});

const mapDispatchToProps = (dispatch) => ({
  initCustomerScreen: () => dispatch(initializeCustomerScreen()),
  fetchCustomers: (payload) => dispatch(fetchCustomer(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerScreen);
